module.exports = __webpack_public_path__ + "img/horizontal_6_1_pp1_6.c58ec7b0.png";